module.exports = __webpack_public_path__ + "static/img/8.a7405f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/3/8.png
// module id = HpFq
// module chunks = 0